import $ from 'jquery';

export default (element, event, selector, handler = selector) => {
  $(element).on(event, selector, wrappedHandler);
  return () => { $(element).off(event, selector, wrappedHandler); };

  function wrappedHandler (event) {
    handler(event.originalEvent);
  }
};
